import { ViewProps } from '.'
import { RegularBenefitVariant } from '../../../../../../typings'
import {
  FormulaView,
  FreeShippingView,
  GiftView,
  MaxPriceView,
  MaxShippingView,
  NominalLoyaltyView,
  NominalShippingView,
  NominalView,
  PercentualLoyaltyView,
  PercentualShippingView,
  PercentualView,
  PriceTableView,
} from '../Variants'

export const VIEW_MAP: Record<
  RegularBenefitVariant,
  (props: ViewProps) => JSX.Element
> = {
  [RegularBenefitVariant.Nominal]: NominalView,
  [RegularBenefitVariant.NominalShipping]: NominalShippingView,
  [RegularBenefitVariant.Percentual]: PercentualView,
  [RegularBenefitVariant.MaxPrice]: MaxPriceView,
  [RegularBenefitVariant.NominalLoyalty]: NominalLoyaltyView,
  [RegularBenefitVariant.PercentualShipping]: PercentualShippingView,
  [RegularBenefitVariant.FreeShipping]: FreeShippingView,
  [RegularBenefitVariant.MaxShipping]: MaxShippingView,
  [RegularBenefitVariant.Gift]: GiftView,
  [RegularBenefitVariant.PercentualLoyalty]: PercentualLoyaltyView,
  [RegularBenefitVariant.Formula]: FormulaView,
  [RegularBenefitVariant.PriceTable]: PriceTableView,
}
